/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-arrow-up-right': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M6.25 3.75V5h7.869L3.75 15.369l.881.881L15 5.881v7.869h1.25v-10z"/>'
  }
})
